import React from "react";
import { App } from "./App";
import Space from "./pages/Space";
import CheckOpenId from "./pages/CheckOpenId";
import { BrowserRouter, Route } from "react-router-dom";

class MyRouter extends React.Component {
  render() {
    const config = this.props.config;

    return (
      <BrowserRouter basename={config.BASE_NAME}>
        <Route
          path="/"
          exact
          render={(props) => <App {...props} {...this.props} />}
        />
        <Route
          path="/redirect_to"
          render={(props) => <Space {...props} {...this.props} />}
        />
        <Route
          path="/checkopenid/:rawdata"
          render={(props) => <CheckOpenId {...props} {...this.props} />}
        />
      </BrowserRouter>
    );
  }
}

export default MyRouter;
